export default class BackofficeOrdersEdit {
  constructor() {
    this.cacheElements();
    this.initializeSelect2();
    this.bindEvents();
    this.applyEntityDataset(this.currentEntityId, true);
    this.refreshOptionsForProduct(this.$productSelect.val());
    this.updateProductPricing();
    this.updateOptionTotals();
    this.updateTotals();
  }

  cacheElements() {
    this.$entitySelect = $("#order_entity_select");
    this.$productSelect = $("#order_product_select");
    this.$optionsSelect = $("#options_select");
    this.$authorSelect = $("#order_author_select");
    this.$engagementCell = $("#engagement_product");
    this.$fasProductCell = $("#fas_product");
    this.$subscriptionProductCell = $("#subscription_product");
    this.$fasOptionsCell = $("#fas_options");
    this.$subscriptionOptionsCell = $("#subscription_options");
    this.$fasTotalCell = $("#fas_total");
    this.$subscriptionTotalCell = $("#subscription_total");

    const $datasetContainer = $("#order-edit-datasets");
    this.entityData = this.safeParseJSON($datasetContainer.attr("data-entities"));
    this.productPricing = this.safeParseJSON($datasetContainer.attr("data-product-pricing"));
    this.optionsByProduct = this.safeParseJSON($datasetContainer.attr("data-options-by-product"));
    this.currentEntityId = $datasetContainer.attr("data-current-entity") || this.$entitySelect.val();
    this.currentAuthorId = $datasetContainer.attr("data-current-author") || this.$authorSelect.val();
    this.hasCustomPricing = $datasetContainer.attr("data-has-custom-pricing") === "true";
    this.hasFar = $datasetContainer.attr("data-has-far") === "true";
    this.hasIru = $datasetContainer.attr("data-has-iru") === "true";
    this.customPricing = this.safeParseJSON($datasetContainer.attr("data-custom-pricing"));
  }

  initializeSelect2() {
    if (this.$entitySelect.length) {
      this.$entitySelect.select2({
        width: "100%",
        placeholder: this.$entitySelect.data("placeholder") || "Sélectionner une entité"
      });
    }

    if (this.$productSelect.length) {
      this.$productSelect.select2({
        width: "100%",
        placeholder: this.$productSelect.data("placeholder") || "Sélectionner un produit"
      });
    }

    if (this.$optionsSelect.length) {
      this.$optionsSelect.select2({
        multiple: true,
        closeOnSelect: false,
        width: "100%"
      });
    }

    if (this.$authorSelect.length) {
      this.$authorSelect.select2({
        width: "100%",
        placeholder: this.$authorSelect.data("placeholder") || "Sélectionner un auteur",
        allowClear: true
      });
    }
  }

  bindEvents() {
    this.$entitySelect.on("change", () => {
      const entityId = this.$entitySelect.val();
      this.applyEntityDataset(entityId, true);
      this.refreshOptionsForProduct(this.$productSelect.val());
    });

    this.$productSelect.on("change", () => {
      this.refreshOptionsForProduct(this.$productSelect.val());
      this.updateProductPricing();
      this.updateOptionTotals();
      this.updateTotals();
    });

    this.$optionsSelect.on("change", () => {
      this.updateOptionTotals();
      this.updateTotals();
    });
  }

  applyEntityDataset(entityId, preserveSelections = true) {
  const entityKey = entityId ? String(entityId) : "";
  this.currentEntityId = entityKey;

    if (!entityKey || entityKey === "null" || entityKey === "undefined") {
      return;
    }

    const payload = this.entityData[entityKey] || {};
    this.productPricing = payload.product_pricing || {};
    this.optionsByProduct = payload.options_by_product || {};

    this.refreshProductList(payload.products || [], preserveSelections);
    this.refreshAuthorList(payload.customers || [], preserveSelections);
  }

  refreshProductList(products, preserveSelections) {
    const previousProductId = this.$productSelect.val();
    const productPlaceholder = this.$productSelect.data("placeholder") || "Sélectionner un produit";

    const existingSelection = preserveSelections && products.some(product => String(product.id) === String(previousProductId))
      ? previousProductId
      : (products[0] ? String(products[0].id) : null);

    if (this.$productSelect.hasClass("select2-hidden-accessible")) {
      this.$productSelect.select2("destroy");
    }

    this.$productSelect.empty();

    products.forEach(product => {
      const optionElement = new Option(product.name, product.id, false, false);
      $(optionElement).attr("data-fas", product.fas);
      $(optionElement).attr("data-subscription", product.subscription);
      $(optionElement).attr("data-engagement", product.engagement);
      this.$productSelect.append(optionElement);
    });

    if (existingSelection) {
      this.$productSelect.val(existingSelection);
    }

    this.$productSelect.select2({
      width: "100%",
      placeholder: productPlaceholder
    });

    this.$productSelect.trigger("change.select2");
    this.$productSelect.trigger("change");
  }

  refreshAuthorList(customers, preserveSelections) {
    const previousAuthor = this.$authorSelect.val();
    const authorPlaceholder = this.$authorSelect.data("placeholder") || "Sélectionner un auteur";

    const existingSelection = preserveSelections && customers.some(customer => String(customer.id) === String(previousAuthor))
      ? previousAuthor
      : null;

    if (this.$authorSelect.hasClass("select2-hidden-accessible")) {
      this.$authorSelect.select2("destroy");
    }

    this.$authorSelect.empty();
    this.$authorSelect.append(new Option("", "", false, false));

    customers.forEach(customer => {
      const optionElement = new Option(customer.name, customer.id, false, false);
      this.$authorSelect.append(optionElement);
    });

    if (existingSelection) {
      this.$authorSelect.val(existingSelection);
    }

    this.$authorSelect.select2({
      width: "100%",
      placeholder: authorPlaceholder,
      allowClear: true
    });

    this.$authorSelect.trigger("change.select2");
    this.$authorSelect.trigger("change");
  }

  refreshOptionsForProduct(productId) {
    const availableOptions = this.optionsByProduct[productId] || [];
    const previouslySelected = (this.$optionsSelect.val() || []).map(String);
    const validSelected = previouslySelected.filter(value => availableOptions.some(option => String(option.id) === value));

    this.$optionsSelect.empty();

    availableOptions.forEach(option => {
      const selected = validSelected.includes(String(option.id));
      const optionElement = new Option(option.name, option.id, selected, selected);
      $(optionElement).attr("data-fas", option.fas);
      $(optionElement).attr("data-subscription", option.subscription);
      this.$optionsSelect.append(optionElement);
    });

    this.$optionsSelect.val(validSelected);
    this.$optionsSelect.trigger("change.select2");
    this.$optionsSelect.trigger("change");
  }

  updateProductPricing() {
    // If custom pricing exists (with FAR/IRU), do not update the pricing cells
    // The custom pricing values should remain as rendered by the server
    if (this.hasCustomPricing && (this.hasFar || this.hasIru)) {
      return;
    }

    const productId = this.$productSelect.val();
    const pricing = this.productPricing[productId] || { fas: 0, subscription: 0, engagement: "--" };

    this.$engagementCell.text(pricing.engagement || "--");
    this.$fasProductCell.attr("data-price", pricing.fas);
    this.$fasProductCell.text(I18n.toCurrency(pricing.fas));
    this.$subscriptionProductCell.attr("data-price", pricing.subscription);
    this.$subscriptionProductCell.text(I18n.toCurrency(pricing.subscription));
  }

  updateOptionTotals() {
    let fas = 0;
    let subscription = 0;

    this.$optionsSelect.find("option:selected").each((_, element) => {
      const $option = $(element);
      fas += Number.parseFloat($option.data("fas")) || 0;
      subscription += Number.parseFloat($option.data("subscription")) || 0;
    });

    this.$fasOptionsCell.attr("data-price", fas);
    this.$fasOptionsCell.text(I18n.toCurrency(fas));
    this.$subscriptionOptionsCell.attr("data-price", subscription);
    this.$subscriptionOptionsCell.text(I18n.toCurrency(subscription));
  }

  updateTotals() {
    // If custom pricing exists (with FAR/IRU), only update with options totals
    // The base product pricing should remain as set by custom pricing
    if (this.hasCustomPricing && (this.hasFar || this.hasIru)) {
      const customTotalOneTime = this.customPricing.total_one_time || 0;
      const customRecurrent = this.customPricing.recurrent_price || 0;
      const optionFas = Number.parseFloat(this.$fasOptionsCell.attr("data-price")) || 0;
      const optionSubscription = Number.parseFloat(this.$subscriptionOptionsCell.attr("data-price")) || 0;

      const fasTotal = customTotalOneTime + optionFas;
      const subscriptionTotal = customRecurrent + optionSubscription;

      this.$fasTotalCell.attr("data-price", fasTotal);
      this.$fasTotalCell.text(I18n.toCurrency(fasTotal));

      this.$subscriptionTotalCell.attr("data-price", subscriptionTotal);
      this.$subscriptionTotalCell.text(I18n.toCurrency(subscriptionTotal));
      return;
    }

    const productFas = Number.parseFloat(this.$fasProductCell.attr("data-price")) || 0;
    const productSubscription = Number.parseFloat(this.$subscriptionProductCell.attr("data-price")) || 0;
    const optionFas = Number.parseFloat(this.$fasOptionsCell.attr("data-price")) || 0;
    const optionSubscription = Number.parseFloat(this.$subscriptionOptionsCell.attr("data-price")) || 0;

    const fasTotal = productFas + optionFas;
    const subscriptionTotal = productSubscription + optionSubscription;

    this.$fasTotalCell.attr("data-price", fasTotal);
    this.$fasTotalCell.text(I18n.toCurrency(fasTotal));

    this.$subscriptionTotalCell.attr("data-price", subscriptionTotal);
    this.$subscriptionTotalCell.text(I18n.toCurrency(subscriptionTotal));
  }

  safeParseJSON(payload) {
    if (!payload) {
      return {};
    }

    try {
      return JSON.parse(payload);
    } catch (error) {
      console.error("Unable to parse JSON payload", error);
      return {};
    }
  }

  onDataChanged() {}

  onDestroy() {
    if (this.$entitySelect && this.$entitySelect.hasClass("select2-hidden-accessible")) {
      this.$entitySelect.select2("destroy");
    }

    if (this.$productSelect && this.$productSelect.hasClass("select2-hidden-accessible")) {
      this.$productSelect.select2("destroy");
    }

    if (this.$optionsSelect && this.$optionsSelect.hasClass("select2-hidden-accessible")) {
      this.$optionsSelect.select2("destroy");
    }

    if (this.$authorSelect && this.$authorSelect.hasClass("select2-hidden-accessible")) {
      this.$authorSelect.select2("destroy");
    }
  }
}
